// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./SeparatorTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Separator-module__Separator__xMBQW {
    display: flex;
}

.Separator-module__SeparatorHorizontal__o7K4E {
    gap: var(--ds-gap-m);
    align-items: center;
    justify-content: center;
    width: 100%;
    color: var(--ds-separator-label-color);
}

.Separator-module__FixedWidth__zktX2 {
    width: var(--ds-10x);
}

.Separator-module__SeparatorVertical__IVSLh {
    flex-direction: column;
    align-self: stretch;
}

.Separator-module__SeparatorLine__uc74i {
    flex: 1;
    border: var(--ds-border-width) solid var(--ds-separator-stroke-color);
}

.Separator-module__SeparatorLineHorizontal__Z7rUX {
    width: var(--ds-2xl);
    height: 0;
}

.Separator-module__SeparatorLineVertical__E_QIL {
    width: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Separator": `Separator-module__Separator__xMBQW`,
	"SeparatorHorizontal": `Separator-module__SeparatorHorizontal__o7K4E`,
	"FixedWidth": `Separator-module__FixedWidth__zktX2`,
	"SeparatorVertical": `Separator-module__SeparatorVertical__IVSLh`,
	"SeparatorLine": `Separator-module__SeparatorLine__uc74i`,
	"SeparatorLineHorizontal": `Separator-module__SeparatorLineHorizontal__Z7rUX`,
	"SeparatorLineVertical": `Separator-module__SeparatorLineVertical__E_QIL`
};
export default ___CSS_LOADER_EXPORT___;
